import { VISIBILITY_STATE } from '../usePushNotifications';

export const isUserLookingAtThisTab = () =>
  document.visibilityState === VISIBILITY_STATE.VISIBLE && document.hasFocus();
